import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { ReactComponent as Cross } from "../../assets/analyse/Cross.svg";
import { ReactComponent as Trash } from "../../assets/analyse/Trash.svg";
import { ReactComponent as Plus } from "../../assets/analyse/Plus.svg";
import LabelsMultiSelect from "../AnalysisPage/components/LabelsMultiSelect";
import DropdownList from "react-widgets/DropdownList";
import ComponentLoading from "../../commonComponents/ComponentLoading";

// REDUX
import {
  fetchFormats,
  fetchMaterials,
  addEcoPackaging,
  addEcoPackagingLocal,
  removeEcoPackaging,
  removeEcoPackagingLocal,
  updateEcoPackagingFormat,
  updateEcoPackagingFormatLocal,
  updateEcoPackagingMaterial,
  updateEcoPackagingMaterialLocal,
  updatePalmOil,
  updatePalmOilLocal,
} from "../../redux/actions/analysisActions";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { format, formatISO } from "date-fns";

function EcoScoreIndicatorsMenu(props) {
  // REDUX ACTIONS
  const dispatch = useDispatch();
  const fetchFormats_rd = (item) => dispatch(fetchFormats(item));
  const fetchMaterials_rd = () => dispatch(fetchMaterials());
  const addEcoPackaging_rd = (item) => dispatch(addEcoPackaging(item));
  const addEcoPackagingLocal_rd = (item) => dispatch(addEcoPackagingLocal(item));

  const removeEcoPackaging_rd = (item) => dispatch(removeEcoPackaging(item));
  const removeEcoPackagingLocal_rd = (item) => dispatch(removeEcoPackagingLocal(item));

  const updateEcoPackagingFormat_rd = (item) => dispatch(updateEcoPackagingFormat(item));
  const updateEcoPackagingFormatLocal_rd = (item) => dispatch(updateEcoPackagingFormatLocal(item));

  const updateEcoPackagingMaterial_rd = (item) => dispatch(updateEcoPackagingMaterial(item));
  const updateEcoPackagingMaterialLocal_rd = (item) => dispatch(updateEcoPackagingMaterialLocal(item));

  const updatePalmOil_rd = (item) => dispatch(updatePalmOil(item));
  const updatePalmOilLocal_rd = (item) => dispatch(updatePalmOilLocal(item));

  //
  const user_info = useSelector((state) => (state.user.user_info ? state.user.user_info : null));
  const formats = useSelector((state) => (state.analysis.formats ? state.analysis.formats : []));
  const materials = useSelector((state) => (state.analysis.materials ? state.analysis.materials : []));
  const eco_packaging = useSelector((state) => (state.analysis.analysis_data.eco_packaging ? state.analysis.analysis_data.eco_packaging : []));
  const palm_oil = useSelector((state) => (state.analysis.analysis_data.palm_oil ? state.analysis.analysis_data.palm_oil : null));
  const analysis_id = useSelector((state) => (state.analysis.analysis_id ? state.analysis.analysis_id : null));

  // fetch format and materials
  useEffect(() => {
    const fetch_fn = async () => {
      await fetchFormats_rd();
      await fetchMaterials_rd();
    };
    if (materials.length === 0 && formats.length === 0) {
      fetch_fn();
    }
  }, []);

  const [loading, setLoading] = useState(false);

  const handleChangeAddEcoPackaging = async () => {
    const item = {
      analysis_id: analysis_id,
      value: { format: { format: "Barquette", ratio: 1 }, material: { materiaux: "Carton", score: 91 } },
      type: "add_eco_packaging",
    };
    const eco_packaging_remote_key = await addEcoPackagingLocal_rd(item);
    item.eco_packaging_remote_key = eco_packaging_remote_key;
    addEcoPackaging_rd(item);
  };
  const handleChangeRemoveEcoPackaging = async (current, i) => {
    const item = {
      analysis_id: analysis_id,
      value: current,
      eco_packaging_remote_key: current[0],
      eco_packaging_id: i,
      type: "remove_eco_packaging",
    };
    await removeEcoPackagingLocal_rd(item);
    removeEcoPackaging_rd(item);
  };
  const handleChangeUpdateEcoPackagingFormat = async (value, current_key, i) => {
    const item = {
      analysis_id: analysis_id,
      value: value,
      eco_packaging_id: i,
      eco_packaging_remote_key: current_key,
      type: "update_eco_packaging_format",
    };
    await updateEcoPackagingFormatLocal_rd(item);
    updateEcoPackagingFormat_rd(item);
  };
  const handleChangeUpdateEcoPackagingMaterial = async (value, current_key, i) => {
    const item = {
      analysis_id: analysis_id,
      value: value,
      eco_packaging_id: i,
      eco_packaging_remote_key: current_key,
      type: "update_eco_packaging_material",
    };
    await updateEcoPackagingMaterialLocal_rd(item);
    updateEcoPackagingMaterial_rd(item);
  };
  const handleChangeUpdatePalmOil = async (value) => {
    const item = {
      analysis_id: analysis_id,
      value: value,
      type: "update_palm_oil",
    };
    await updatePalmOilLocal_rd(item);
    updatePalmOil_rd(item);
  };

  return (
    <div>
      <div className=" h-full absolute">
        {/* <div className="w-[250px] h-[200px] absolute"> */}
        <div className="w-[850px] h-[590px] bg-white shadow border-[1px] ml-[260px] mt-[-10px] border-[#BEC4CA] relative z-20 rounded-xl">
          {/* <div className="h-[50px] w-full flex items-center justify-between"></div> */}
          <div className="h-[50px] w-full flex items-center justify-between mt-[10px]">
            <p className="font-Poppins-SemiBold text-sm ml-[20px]">{"Indicateurs complémentaires pour l'éco-score"}</p>
            <button
              onClick={() => {
                props.setEcoScoreIndicatorsMenu(false);
              }}
            >
              <Cross height={20} />
            </button>
          </div>

          <div className="flex items-center justify-center  mt-[20px]">
            <LabelsMultiSelect is_reduce={user_info && (user_info.organization_info.role.access.analyse.write ? props.is_reduce : true)} />

            <div className="flex items-center justify-center">
              <p className="font-Poppins-SemiBold m-[5px]">Huile de palme</p>

              <DropdownList
                filter={"contains"}
                disabled={user_info && (props.is_reduce ? true : user_info.organization_info.role.access.analyse.write ? false : true)}
                // disabled={props.is_reduce}
                className="w-[200px]"
                value={palm_oil}
                onChange={handleChangeUpdatePalmOil}
                placeholder="choisir"
                data={["oui", "non"]}
              />
            </div>
          </div>

          <div>
            <p className="font-Poppins-SemiBold m-[5px] mx-[20px] mt-[40px]">Circularité de l'emballage</p>

            <div className="w-[810px] h-full mx-[20px] bg-[#F3F5F7]/40 rounded-t shadow mt-[10px]">
              <div className="h-[40px] flex items-center font-Poppins-SemiBold bg-white">
                <div className="w-[405px] h-[40px] border-dotted border-r-[0.1px] border-[#F3F5F7] flex justify-center items-center">
                  <p
                    onClick={() => {
                      console.log("formats", formats);
                      console.log("materials", materials);
                    }}
                  >
                    {" "}
                    Format
                  </p>
                </div>
                <div className="w-[405px] h-[40px] border-dotted border-l-[0.1px] border-[#F3F5F7] flex justify-center items-center">
                  <p> Matériaux</p>
                </div>
              </div>
              {Object.values(eco_packaging).length > 0 &&
                Object.entries(eco_packaging).map((current, i) => {
                  return (
                    <>
                      {/* SHOW ORIGIN DATA */}
                      {/* {Object.values(Object.values(data).find((i) => i.category.name === "K_Raw_Materials").inputs).map((current, i) => {
                  return ( */}
                      <div
                        className="flex bg-[#F3F5F7]"
                        //   key={`${i}`}
                      >
                        <div className="h-[40px] w-[405px] flex items-center justify-center border-dotted border-r-[0.1px] border-[#F3F5F7]">
                          <button
                            onClick={async () => {
                              // await handleChangeRemoveOrigin(current, i);
                              await handleChangeRemoveEcoPackaging(current, i);
                            }}
                          >
                            <Trash height={15} />
                          </button>
                          <DropdownList
                            filter={"contains"}
                            disabled={user_info && (props.is_reduce ? true : user_info.organization_info.role.access.analyse.write ? false : true)}
                            // disabled={props.is_reduce}
                            className="h-[40px] w-[340px] bg-[#F3F5F7] py-[2px] pr-[10px]"
                            data={formats}
                            dataKey="format"
                            textField="format"
                            value={current[1].format}
                            onChange={async (value) => {
                              // setLoading(true);
                              await handleChangeUpdateEcoPackagingFormat(value, current[0], i);
                              // setLoading(false);
                            }}
                          />
                        </div>
                        <div className="w-[405px] h-[40px] border-dotted border-l-[0.1px] border-[#F3F5F7] flex justify-center items-center">
                          <DropdownList
                            filter={"contains"}
                            disabled={user_info && (props.is_reduce ? true : user_info.organization_info.role.access.analyse.write ? false : true)}
                            // disabled={props.is_reduce}
                            className="h-[40px] w-[340px] bg-[#F3F5F7] py-[2px] pr-[10px]"
                            data={materials}
                            dataKey="materiaux"
                            textField="materiaux"
                            value={current[1].material}
                            onChange={async (value) => {
                              // setLoading(true);
                              await handleChangeUpdateEcoPackagingMaterial(value, current[0], i);
                              // setLoading(false);
                            }}
                          />
                        </div>
                      </div>
                    </>
                  );
                })}

              {/* ); } */}

              {/* )} */}
              <div className="h-[40px] w-full flex bg-[#F3F5F7]">
                <button
                  disabled={user_info && (props.is_reduce ? true : user_info.organization_info.role.access.analyse.write ? false : true)}
                  // disabled={props.is_reduce}
                  className="h-[40px] w-[200px] border-dotted border-r-[1px] border-[#F3F5F7] flex items-center"
                  onClick={async () => {
                    setLoading(true);
                    await handleChangeAddEcoPackaging();
                    setLoading(false);
                  }}
                >
                  {/* <Plus height={15} /> */}
                  {loading ? <ComponentLoading height={20} style={"flex items-center justify-center ml-[11px]"} /> : <Plus height={15} />}
                  {/* {loading ? <ComponentLoading height={20} style={"flex items-center justify-center ml-[11px]"} /> : <Plus height={15} />} */}
                  <p className="text-sm text-gray-400">Ajouter un matériaux</p>
                </button>
                <div className="w-[200px] h-[40px] border-dotted border-l-[1px] border-[#F3F5F7]"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

EcoScoreIndicatorsMenu.propTypes = {};

export default EcoScoreIndicatorsMenu;
